import * as Types from '../../generated/types';

import gql from 'graphql-tag';
export type AppBarStoreFragment = { __typename?: 'Store', theme: { __typename?: 'StoreTheme', brandLogo?: { __typename?: 'ImageMedia', image?: { __typename?: 'Image', url: any } | null } | null }, boards: { __typename?: 'BoardConnection', totalCount: number, edges: Array<{ __typename?: 'BoardEdge', node: { __typename?: 'Board', id: string, isVisible: boolean, displayOrder: number, name: string, handle: string } }> }, categories: { __typename?: 'CategoryConnection', edges: Array<{ __typename?: 'CategoryEdge', node: { __typename?: 'Category', id: string, name: string, handle: string, level: number, parentId?: string | null, isLeaf: boolean, isRoot: boolean, rank: number, children: Array<{ __typename?: 'Category', id: string, name: string, handle: string, level: number, parentId?: string | null, isLeaf: boolean, isRoot: boolean, rank: number }> } }> } };

export const AppBarStoreFragmentDoc = gql`
    fragment AppBarStore on Store {
  theme {
    brandLogo {
      image {
        url
      }
    }
  }
  boards {
    edges {
      node {
        id
        isVisible
        displayOrder
        name
        handle
      }
    }
    totalCount
  }
  categories(first: 10) {
    edges {
      node {
        id
        name
        handle
        level
        parentId
        isLeaf
        isRoot
        rank
        children {
          id
          name
          handle
          level
          parentId
          isLeaf
          isRoot
          rank
        }
      }
    }
  }
}
    `;